<template>
  <v-list-item link class="pa-0 pr-4 d-flex" @click="goToEntity">
    <v-icon
      class="pl-5 pr-5"
      :color="COLORS_BY_ENTITY[item.response.entityType]"
    >
      {{ ICONS_BY_ENTITY[item.response.entityType] }}
    </v-icon>

    <div class="result-content pt-2 pr-2">
      <text-highlight
        highlightClass="yellow lighten-1"
        class="subtitle-2 blue-grey--text text--darken-3"
        highlightComponent="span"
        :queries="highlights"
        :title="title"
      >
        {{ title }}
      </text-highlight>

      <div class="caption blue-grey--text d-flex">
        {{ date }}
      </div>
    </div>

    <div v-if="matchingFieldsToShowInTooltip.length > 0">
      <v-tooltip max-width="300px" bottom>
        <template v-slot:activator="{ on }">
          <v-icon color="blue-grey" size="16px" v-on="on"
            >mdi-information-outline
          </v-icon>
        </template>

        {{ $t('explore.matching_fields_tooltip') }}

        <br />

        <ul>
          <li v-for="field in matchingFieldsToShowInTooltip" :key="field">
            {{ $t(`explore.fields.${field}`) }}
          </li>
        </ul>
      </v-tooltip>
    </div>
  </v-list-item>
</template>

<script>
import { utils } from 'frontend-js-shared'
import trackerMixin from '@/mixins/tracking/trackerMixin.vue'

export default {
  name: 'SearchBarResultItem',

  mixins: [trackerMixin],

  props: {
    item: {
      type: Object,
      required: true,
    },

    searchValue: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      ICONS_BY_ENTITY: this.$constants.ICONS_BY_ENTITY,
      COLORS_BY_ENTITY: this.$constants.ICON_COLORS_BY_ENTITY,
      ENTITY_TYPES: this.$constants.exploreEntityTypes,
    }
  },

  computed: {
    entity() {
      return this.item?.response
    },

    title() {
      return this.entity.situation ?? this.entity.name
    },

    defaultHighlightQueries() {
      return [this.searchValue, ...(this.searchValue?.split?.(' ') ?? [])]
    },

    highlights() {
      const nameHighlights =
        this.item?.highlights?.situation || this.item?.highlights?.name
      return nameHighlights || this.defaultHighlightQueries
    },

    date() {
      return utils.dates.humanDate(this.entity.updatedAt)
    },

    matchingFieldsToShowInTooltip() {
      const fields = this.item?.matchingFields ?? []
      return fields
        .filter(field => field !== 'name' && field !== 'situation') // 'name' and 'situation' are already displayed in the title and can be highlighted, thus they are not listed in the tooltip
        .map(field => field.replace('.', '_')) // replace '.' with '_' to match the translation keys
    },
  },

  methods: {
    goToEntity() {
      const { entityType, id, organization } = this.item.response
      switch (entityType) {
        case this.ENTITY_TYPES.improvementIdea:
          this.$emit('selectResult', `/rev/${organization}/${id}`)
          break
        case this.ENTITY_TYPES.problemSolving:
          this.$emit('selectResult', `/problem-solving/${organization}/${id}`)
          break
        case this.ENTITY_TYPES.quickAction:
          this.$emit('selectResult', `/quick-action/${organization}/${id}`)
          break
        case this.ENTITY_TYPES.routine:
          this.$emit('selectResult', `/routine-executions/${id}`)
          break
        case this.ENTITY_TYPES.finding:
          this.$emit('openFinding', id)
          break
        case this.ENTITY_TYPES.challenge:
          this.$emit('selectResult', `/challenge/${organization}/${id}`)
          break
        case this.ENTITY_TYPES.task:
          this.$emit('openTask', id)
          break
        default:
      }

      this.trackExploreSearch({
        action: 'clickSuggestion',
        itemId: id,
      })
    },
  },
}
</script>

<style scoped>
.result-content {
  flex: 1 1 auto;
  padding-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
